<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    //this.prohibit()
  },
  methods: {
    prohibit () {
      // 禁止鼠标右键菜单
      document.oncontextmenu = function (e) {
        return false
      }
    }
  }
}
</script>

<style>

html,body,#app{
    width: 100%;
    height: 100%;
  }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.collapsed-menu .ivu-menu-opened{
       position: relative;
     }
.collapsed-menu .ivu-menu-opened .ivu-menu{
       display: none!important;
       position: relative;
     }
 .collapsed-menu .ivu-menu-submenu{
   position: relative;
 }
  .collapsed-menu .ivu-menu-submenu-title-icon{
    display: none;
  }
.collapsed-menu .ivu-menu-submenu:hover .ivu-menu{
       display: block!important;
       position: absolute;
       left: 80px;
       top:20px;
       width: 150px;
       background-color:#101117;
     }
.collapsed-menu .ivu-menu-submenu:hover .ivu-menu span{
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue